import { render, staticRenderFns } from "./confirmDeletionClick2moneyModal.vue?vue&type=template&id=2100442e&"
import script from "./confirmDeletionClick2moneyModal.vue?vue&type=script&lang=js&"
export * from "./confirmDeletionClick2moneyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports